import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Carray(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
     
 <title>What is an Array in C tutorial For Beginners</title>
 <meta name="description" content="array in c tutorial for beginners.Array in C is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C array,One-dimensional Array in C,Multi-dimensional Array in C,c array,c array string,c array of strings,c array length,c array initialization,c array to pointer,c array pointer,c array size,c array of pointers,c array declaration,c array of structs,c array size,c array creation,c array define,c array copy,arraylist in c,c arraylist.learn code in free,c programming tutorial for beginners,learn code in free online" />
 <link rel="canonical" href="https://www.codeexampler.com/c-array" />
 </Helmet>

 <div className='lg:pl-56'>


    <h1 className="m-4 mh1">What is an Array in C Programming</h1>

    <div className="first">
        <a href="/c-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, This is a collection of similar types of data and stored manually consecutively under one name<br/>
2, The index number will be different<br/>
3, Main purpose of the array is used to handle a large volume of data of some type more easily
</p>
<h2 className="mt-4 mh2">Types of the array in C:
</h2>
 

<h2 className="headings">There are 2 types of Array in C:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-2">1. </span>
            <span className="qwerty-4">one-dimensional array in C</span>
              {"\n"} 
            {"\n"}
              <span className="qwerty-2">2. </span>
            <span className="qwerty-10">multi-dimensional array in C</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>       




<h2 className="headings">Basic array C Style Examples:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-2">Ex-</span>
            <span className="qwerty-3"> &#123;</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">20</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">30</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">40</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">50</span>
            <span className="qwerty-3">&#125;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>  



<h2 className="headings">Array in C Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-3">type </span>
            <span className="qwerty-5">array_name</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">size</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-2">Ex- </span>
              <span className="qwerty-3">int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">4</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3">    int </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">5</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>        
    


<h2 className="headings">Initialize Array Example in C:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">5</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-3"> &#123;</span>
              <span className="qwerty-1">20</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">40</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">30</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">60</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">50</span>
            <span className="qwerty-3">&#125;</span>
            <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty-3">int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1"></span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-3"> &#123;</span>
              <span className="qwerty-1">1</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">2</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">3</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">5</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">8</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">10</span>
            <span className="qwerty-3">&#125;</span>
            <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty-3">float </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1"></span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-3"> &#123;</span>
              <span className="qwerty-1">2.8</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">20.46</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">8.6</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">4.5</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">46.50</span>
              <span className="qwerty-4">,</span>
              <span className="qwerty-1">50</span>
            <span className="qwerty-3">&#125;</span>
            <span className="qwerty-4">;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>        


<h2 className="mt-4 mh2">How to print an array in c</h2>



<h2 className="headings">Q-Write a program to input an array of 10 elements and print only even elements?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
        <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-3"> int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">10</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter 10 elements:</span>
        <span className="qwerty-4">");</span>      
            {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
            <span className="qwerty-6"> scantf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-1"> &amp;</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-6">  if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">[</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">]</span>
                <span className="qwerty">%</span>
                <span className="qwerty-1">2</span>
                <span className="qwerty"> ==</span>
                <span className="qwerty-1"> 0</span>
                <span className="qwerty-4">) </span>
                {"\n"}
        <span className="qwerty-4">  &#123;</span>
        {"\n"}
        <span className="qwerty-8">   printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4">  &#125;</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
        </pre>
      </div>        
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter 10 elements:</span>                   
                  {"\n"}         
                  <span className="qwerty-1">33</span>                   
                  {"\n"}         
                  <span className="qwerty-1">45</span>                   
                  {"\n"}         
                  <span className="qwerty-1">16</span>                   
                  {"\n"}         
                  <span className="qwerty-1">24</span>                   
                  {"\n"}         
                  <span className="qwerty-1">54</span>                   
                  {"\n"}         
                  <span className="qwerty-1">23</span>                   
                  {"\n"}     
                  <span className="qwerty-1">51</span>                   
                  {"\n"}                  
                  <span className="qwerty-1">95</span>                   
                  {"\n"}         
                  <span className="qwerty-1">6</span>                   
                  {"\n"}         
                  <span className="qwerty-1">45</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Even numbers in the given array are: </span>                   
                  {"\n"}         
                  <span className="qwerty-1">16</span>                   
                  {"\n"}         
                  <span className="qwerty-1">24</span>                   
                  {"\n"}         
                  <span className="qwerty-1">54</span>                   
                  {"\n"}         
                  <span className="qwerty-1">6</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 


<p className="mt-4 para">If you don't know about for loop in C so check on <a href="https://www.codeexampler.com/c-for-loop">C for loop tutorial</a>.</p>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q- Write a program to input an array of 10 elements and print only even elements?
</Card.Header>
  <Card.Body>
    <Card.Text>
    #include &#60;stdio.h&#62;<br/>
int main()<br/>
&#123;<br/>
int a[10],i, maximum;<br/>
   printf("enter 10 elements\n");<br/>
   for(i=0;i&#60;10;i++)<br/>
  scanf("%d",&#38;a[i]);<br/>
   maximum=a[0];<br/>
   for(i=0;i&#60;10;i++)<br/>
   &#123;<br/>
   if (a[i]&#62;maximum)<br/>
   maximum=a[i];<br/>
   &#125;<br/>
   printf("maximum=%d",maximum);<br/>
   return 0; <br/>
   &#125;<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>enter 10 elements <br/>33<br/>
45<br/>
16<br/>
24<br/>
54<br/>
23<br/>
51<br/>
95<br/>
6<br/>
45<br/>
maximum=95</Card.Footer>
</Card>




<h2 className="headings">Q-Write a program to input an array of 8 elements and print its reverse?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
        <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-3"> int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">10</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter 8 elements:</span>
        <span className="qwerty-4">");</span>      
            {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">8</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
            <span className="qwerty-6"> scantf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-1"> &amp;</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Reverse</span>
        <span className="qwerty-4">");</span>      
            {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">8</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">--</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4">  &#125;</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
        </pre>
      </div>        
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter 8 elements:</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-1">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4</span>                   
                  {"\n"}     
                  <span className="qwerty-1">6</span>                   
                  {"\n"}                  
                  <span className="qwerty-1">7</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Reverse: </span>                   
                  {"\n"}         
                  <span className="qwerty-1">7 6 4 9 3 2 5 4</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 


<p className="mt-4 para">If you don't know about input in C so check on the <a href="https://www.codeexampler.com/c-input">C input tutorial</a>.</p>


<h2 className="headings">Q-Write a program to input an array of 10 elements and print maximum in C?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
        <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">,</span>                     
        <span className="qwerty-5">max</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-3"> int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">10</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter 10 elements:</span>
        <span className="qwerty-4">");</span>      
            {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
            <span className="qwerty-6"> scantf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-1"> &amp;</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-5"> max</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">];</span>
        {"\n"}     
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-6">  if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">[</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">]</span>
                <span className="qwerty">&#62;</span>
                <span className="qwerty-5"> max</span>
                <span className="qwerty-4">) </span>
                {"\n"}
                <span className="qwerty-5">  max</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">];</span>
                {"\n"}
              <span className="qwerty-4">  &#125;</span>
        {"\n"}        
        <span className="qwerty-8">   printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Maximum : </span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5">max</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
        </pre>
      </div>        
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter 10 elements:</span>                   
                  {"\n"}         
                  <span className="qwerty-1">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4</span>                   
                  {"\n"}     
                  <span className="qwerty-1">7</span>                   
                  {"\n"}                  
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-1">6</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Maximum : </span>                            
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 



<h2 className="headings">Q-Write a program to add two arrays and results should be stored into a third array in C?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
        <code>
      {"\n"}
         <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">,</span>    
            <span className="qwerty-5"> a</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">5</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">, </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">5</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">, </span>        
            <span className="qwerty-5">c</span>
            <span className="qwerty-4">[</span>
            <span className="qwerty-1">5</span>
            <span className="qwerty-4">]</span>
            <span className="qwerty-4">; </span>
            {"\n"}
            <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter 5 elements of A:</span>
        <span className="qwerty-4">");</span>      
            {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">5</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
            <span className="qwerty-6"> scanf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-1"> &amp;</span>
        <span className="qwerty-5">a</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
            <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter 5 elements of B:</span>
        <span className="qwerty-4">");</span>      
            {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">5</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
            <span className="qwerty-6"> scanf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-1"> &amp;</span>
        <span className="qwerty-5">b</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4"></span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
                <span className="qwerty-5">  c</span>
                <span className="qwerty-4">[</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">]</span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-4">[</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">]</span>
                <span className="qwerty">+</span>
                <span className="qwerty-5"> b</span>
                <span className="qwerty-4">[</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">]</span>
                <span className="qwerty-4">;</span>
                {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5">c</span>
        <span className="qwerty-4">[</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">]</span>
        <span className="qwerty-4">);</span>
        {"\n"}
                {"\n"}
              <span className="qwerty-4">  &#125;</span>
        {"\n"}        
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
      {"\n"}{"\n"}
    </code>
        </pre>
      </div>        
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter 5 elements:</span>                   
                  {"\n"}         
                  <span className="qwerty-1">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">6</span>                   
                  {"\n"}         
                  <span className="qwerty-1">8</span>                   
                  {"\n"}         
                  <span className="qwerty-1">12</span>                   
                  {"\n"}         
                  <span className="qwerty-5">Enter 5 elements:</span>                   
                  {"\n"}         
                  <span className="qwerty-1">1</span>                   
                  {"\n"}     
                  <span className="qwerty-1">3</span>                   
                  {"\n"}                  
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-1">7</span>                   
                  {"\n"}         
                  <span className="qwerty-1">10</span>                   
                  {"\n"}         
                  <span className="qwerty-3">Addition of both arrays : </span>                            
                  <span className="qwerty-1">3 7 11 15 22</span>                   
                  {"\n"}         
                  {"\n"}         
                </code>
                </pre>
                </div> 


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Carray;